/* Cycle Closet PDP behaviour - Sep 2026 facelift */
(function () {
  'use strict';

  function variantData() {
    var el = document.querySelector(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function currentVariant() {
    var input = document.querySelector('.product__info-container form[data-type="add-to-cart-form"] input[name="id"]');
    if (!input) input = document.querySelector('.product__info-container input[name="id"]');
    if (!input) return null;
    var id = parseInt(input.value, 10);
    var list = variantData();
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  /* ---------- option label: show the selected value inline ---------- */
  function syncOptionLabels() {
    var variant = currentVariant();
    document.querySelectorAll('.cc-opt-value').forEach(function (span) {
      var pos = parseInt(span.getAttribute('data-option-position'), 10);
      var value = '';
      if (variant) value = variant['option' + pos] || '';
      if (!value) {
        var checked = document.querySelector(
          'variant-radios fieldset:nth-of-type(' + pos + ') input[type="radio"]:checked'
        );
        if (checked) value = checked.value;
      }
      span.textContent = value ? ': ' + value : '';
    });
  }

  /* ---------- sale badge shows the saving, not the word Sale ---------- */
  function updateSaveBadge() {
    var wrap = document.querySelector('.product__info-container .price');
    if (!wrap) return;
    var badge = wrap.querySelector('.price__badge-sale');
    var wasEl = wrap.querySelector('.price__sale s .price-item--regular');
    var nowEl = wrap.querySelector('.price__sale .price-item--sale');
    if (!badge || !wasEl || !nowEl) return;

    var parse = function (el) {
      var raw = (el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
      return parseFloat(raw);
    };
    var was = parse(wasEl);
    var now = parse(nowEl);
    if (!isFinite(was) || !isFinite(now) || was <= now) return;

    var diff = was - now;
    var symbolMatch = (nowEl.textContent || '').match(/[^0-9\s]+/);
    var symbol = symbolMatch ? symbolMatch[0] : '$';
    var amount = Math.abs(diff % 1) < 0.005 ? diff.toFixed(0) : diff.toFixed(2);
    badge.textContent = 'Save ' + symbol + amount;
  }

  /* ---------- quantity + add to cart on one row ---------- */
  function buildBuyBoxRow() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    if (container.querySelector('.cc-buybox-row')) return;
    var qty = container.querySelector('.product-form__quantity');
    if (!qty) return;
    var buttonsBlock = container.querySelector('.product-form');
    if (!buttonsBlock) return;
    var qtyBlock = qty.closest('[id^="Quantity-"], .product__info-container > div') || qty;
    var buyBlock = buttonsBlock.closest('.product__info-container > div') || buttonsBlock;
    if (qtyBlock === buyBlock) return;

    var row = document.createElement('div');
    row.className = 'cc-buybox-row';
    buyBlock.parentNode.insertBefore(row, qtyBlock);
    var buttonsWrap = document.createElement('div');
    buttonsWrap.className = 'cc-buybox-row__buttons';
    row.appendChild(qtyBlock);
    buttonsWrap.appendChild(buyBlock);
    row.appendChild(buttonsWrap);
  }

  /* ---------- size guide + find my size on one row ---------- */
  function buildSizeRow() {
    var sg = document.querySelector('.cc-sg');
    var find = document.querySelector('.cc-find-size');
    if (!sg || !find) return;
    if (document.querySelector('.cc-sg__row')) return;
    var sgBtn = sg.querySelector('.cc-sg__open');
    var findBtn = find.querySelector('.cc-find-size__open');
    if (!sgBtn || !findBtn) return;

    var row = document.createElement('div');
    row.className = 'cc-sg__row';
    sg.insertBefore(row, sg.firstChild);
    row.appendChild(sgBtn);
    var sep = document.createElement('span');
    sep.className = 'cc-sg__sep';
    row.appendChild(sep);
    row.appendChild(findBtn);
    find.remove();
  }

  /* ---------- stock status + dispatch cutoff ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function adelaideNow() {
    var parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Adelaide', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      weekday: o.weekday,
      hour: parseInt(o.hour, 10) % 24,
      minute: parseInt(o.minute, 10)
    };
  }

  function updateStock() {
    var box = document.querySelector('.cc-stock');
    if (!box) return;
    var statusEl = box.querySelector('.cc-stock__status');
    var textEl = box.querySelector('.cc-stock__text');
    var dispatchEl = box.querySelector('.cc-stock__dispatch');
    var countEl = box.querySelector('.cc-stock__countdown');
    var variant = currentVariant();

    var available = variant ? variant.available : box.getAttribute('data-available') === 'true';
    var extWarehouse = box.getAttribute('data-ext-warehouse') === 'true';

    if (!available) {
      statusEl.setAttribute('data-state', 'out');
      textEl.textContent = box.getAttribute('data-label-out') || 'Out of stock';
      if (dispatchEl) dispatchEl.hidden = true;
      return;
    }

    if (extWarehouse) {
      statusEl.setAttribute('data-state', 'backorder');
      textEl.textContent = box.getAttribute('data-label-supplier') || 'In stock at supplier warehouse';
      if (dispatchEl) dispatchEl.hidden = true;
      return;
    }

    statusEl.setAttribute('data-state', 'in');
    textEl.textContent = box.getAttribute('data-label-in') || 'In stock, ready to ship';

    if (!dispatchEl || !countEl) return;
    var cutoffHour = parseInt(box.getAttribute('data-cutoff-hour') || '14', 10);
    var now = adelaideNow();
    var weekend = now.weekday === 'Sat' || now.weekday === 'Sun';
    var minutesLeft = (cutoffHour * 60) - (now.hour * 60 + now.minute);

    if (weekend || minutesLeft <= 0) {
      dispatchEl.hidden = true;
      return;
    }
    var h = Math.floor(minutesLeft / 60);
    var m = minutesLeft % 60;
    countEl.textContent = (h > 0 ? h + 'h ' : '') + pad(m) + 'm';
    dispatchEl.hidden = false;
  }

  function refresh() {
    syncOptionLabels();
    updateSaveBadge();
    updateStock();
  }

  function init() {
    buildBuyBoxRow();
    buildSizeRow();
    refresh();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects, .product-form__input')) {
        setTimeout(refresh, 60);
      }
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(refresh, 50); });
    }
    setInterval(updateStock, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
